// A sample role for review builds only (REACT_APP_CAREERS_DEMO=true). It has
// one screening question of every type the admin can set up, including
// conditional ones, so the whole form can be tried without creating a real
// job. Applying to it never reaches the API: the email code is always 1234
// and sending only shows the confirmation screen.

export const DEMO_ENABLED = process.env.REACT_APP_CAREERS_DEMO === "true";
export const DEMO_SLUG = "sample-role-all-question-types";
export const DEMO_CODE = "1234";

const q = (id, order, question_type, text, extra = {}) => ({
  id,
  order,
  question_type,
  text,
  is_required: true,
  is_conditional: false,
  parent_question_id: null,
  show_when_parent_answer: null,
  show_when_parent_options: [],
  options: [],
  ...extra,
});

const options = (...rows) => rows.map(([id, text]) => ({ id, text }));

export const DEMO_JOB = {
  id: "demo",
  demo: true,
  slug: DEMO_SLUG,
  title: "Sample role: every question type",
  department: { id: 0, name: "Demo" },
  expiry_date: null,
  // Old on purpose: the sample sits at the bottom of the list, without "New".
  created_at: "2026-01-01T00:00:00Z",
  description: [
    "This sample role is for trying the application form. Nothing you send here reaches the recruitment team.",
    "",
    "The Role",
    "Use it to see how each kind of screening question looks and how it is checked: Yes/No, one choice, several choices, numbers with a unit, years of experience and free text. Some questions only appear after certain answers.",
    "",
    "Requirements",
    "• Your own email address, to see the confirmation step (the code is always 1234).",
    "• Any PDF or Word file as the CV.",
  ].join("\n"),
  questions: [
    q(9001, 1, "boolean", "Do you have the right to work in the UAE?"),
    q(9002, 2, "text", "Tell us about your visa situation", {
      is_conditional: true,
      parent_question_id: 9001,
      show_when_parent_answer: "['No']",
    }),
    q(9003, 3, "single_choice", "Which shift suits you best?", {
      options: options([90031, "Morning"], [90032, "Evening"], [90033, "Either"]),
    }),
    q(9004, 4, "boolean", "Can you work until 1 am at weekends?", {
      is_conditional: true,
      parent_question_id: 9003,
      show_when_parent_options: [90032, 90033],
    }),
    q(9005, 5, "multiple_choice", "Which areas could you work in?", {
      options: options(
        [90051, "Dubai Marina"],
        [90052, "Downtown Dubai"],
        [90053, "JBR"],
        [90054, "Abu Dhabi"],
      ),
    }),
    q(9006, 6, "numeric", "What is your notice period? (in days)"),
    q(9007, 7, "numeric", "What is your monthly salary expectation? (in AED)"),
    q(9008, 8, "experience_years", "How many years of restaurant experience do you have?"),
    q(9009, 9, "text", "Anything else you'd like us to know?", { is_required: false }),
  ],
};

export const isDemoSlug = (slug) => DEMO_ENABLED && slug === DEMO_SLUG;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Same shapes as the real API calls, so the form can't tell the difference.
export const demoApi = {
  sendCode: () => wait(400),
  resendCode: () => wait(400),
  verifyCode: async ({ otp }) => {
    await wait(300);
    if (otp !== DEMO_CODE) {
      const error = new Error("Invalid code");
      error.response = { data: { error: `That code didn't work. For the sample role it's ${DEMO_CODE}.` } };
      throw error;
    }
  },
  apply: async () => {
    await wait(700);
    return { data: { application_reference: "SAMPLE-0001" } };
  },
};
